/*
 * Function imports
 */

import { INIT_section } from "./functions/section";
import { INIT_sliders } from "./functions/sliders";
import { INIT_toggleItem } from "./functions/toggle-item";
import { INIT_tabs } from "./functions/tabs";
import GlossaryList from "./classes/GlossaryList";
import StickyHeader from "./functions/sticky-header";

// Inits
INIT_section();
INIT_sliders(true);
INIT_toggleItem();
INIT_tabs();

// Header
new StickyHeader();

// Footer
footerHeights();

window.addEventListener("resize", () => {
  footerHeights();
});

function footerHeights() {
  const footerTop = document.querySelector(".g-footer--top");
  const footerQA = document.querySelector(".g-footer--q-plus-you");
  const footerQABottom = document.querySelector(
    ".g-footer--q-plus-you--bottom"
  );

  if (footerTop && footerQA) {
    const newHeight = footerTop.offsetHeight + "px";

    footerQA.style.marginBottom = "-" + newHeight;
    footerQABottom.style.height = newHeight;
  }
}

// Glossary
const ppGroups = [...document.querySelectorAll("[gl-group]")];
for (let i = 0; i < ppGroups.length; i++) {
  new GlossaryList({
    key: ppGroups[i].getAttribute("gl-group"),
    perPage: 5,
  });
}

// Stockists
const stockists = [...document.querySelectorAll(".section--stockists-accordion .accordion__item")];
if (stockists) {
  stockists.forEach(item => {
    if (item.querySelector('.g-col')) {
    } else {
      item.style.display = 'none';
    }
  });
}

// CMS
if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    console.log('Load');
    INIT_section();
    INIT_sliders(true);
  });

  document.addEventListener('shopify:section:reorder', () => {
    console.log('Reorder');
    INIT_section();
  });

  document.addEventListener('shopify:section:unload', () => {
    console.log('Unload');
    INIT_section();
  });

  document.addEventListener('shopify:section:select', () => {
    console.log('Select');
    INIT_section();
    INIT_sliders(true);
  });

  document.addEventListener('shopify:section:deselect', () => {
    console.log('Deselect');
    INIT_section();
  });

  document.addEventListener('shopify:block:select', () => {
    console.log('Block select');
    INIT_section();
  });

  document.addEventListener('shopify:block:deselect', () => {
    console.log('Block deselect');
    INIT_section();
  });
}

function isInViewport(element) {
  // Get the bounding client rectangle position in the viewport
  var bounding = element.getBoundingClientRect();

  // Checking part. Here the code checks if it's *fully* visible
  // Edit this part if you just want a partial visibility
  if (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  ) {
      return true;
  } else {
      return false;
  }
}

function counterAnimationHandler() {
  const counters = document.querySelectorAll('.js-g-counter')
  counters.forEach(counter => {
    counter.innerText = '0' //set default counter value
    counter.dataset.count = 0;
    const updateCounter = () => {
      const target = +counter.getAttribute('data-target') //define increase couter to it's data-target
      const count = +counter.dataset.count //define increase couter on innerText

      const increment = target / 200 // define increment as counter increase value / speed

      if (count < target) {
        const newCount = Math.ceil(count + increment);
        counter.dataset.count = newCount;
        counter.innerText = numberWithCommas(newCount);
        setTimeout(updateCounter, 1);
      } else {
        counter.innerText = numberWithCommas(target); //if default value is bigger that date-target, show data-target
      }
    }

    updateCounter() //call the function event
  })

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}

window.addEventListener('scroll', function (event) {
  const counterElem = document.querySelector('.js-g-counter-wrapper');

  if (counterElem) {
    if (isInViewport(counterElem)) {
      if (!counterElem.classList.contains('is-animated')) {
        setTimeout(() => {
          counterAnimationHandler();
        }, 300);

        counterElem.classList.add('is-animated');
      }
    } else {
      counterElem.classList.remove('is-animated');
    }
  }
}, false);